const PARAGRAPH_CUSTOM_LINKS_LIST = (uuid: string, language: string) => `
  blockDataUUID(uuid: "${uuid}", language: "${language}") {
    ... on LinksBlock {
      id
      title
      type
      uuid
      linksTheme
      linksButtons {
        backgroundImage
        button {
          title
          url
        }
        icon
        text
        uuid
      }
      blurb
      header
      iconLinks
    }
  }
`;

export default PARAGRAPH_CUSTOM_LINKS_LIST;
